module.exports = __webpack_public_path__ + "media/splash/launch-1242x2688-f5b6a50b.png";